<template lang="pug">
  rc-modal.remove-sheets-modal(v-if="isOpen" width="80em")
    router-view.router-view(
      name="removeSheets"
      v-rc-loader="loading"
      :establishment="establishment"
      :sheetAggregates="sheetAggregates"
      :destinationSource="destinationSource"
      :newEstablishmentName="newEstablishmentName"
      :selectedEstablishment="selectedEstablishment"
      :potentialEstablishments="potentialEstablishments"
      @changeDestinationSource="val => destinationSource = val"
      @changeNewEstablishmentName="val => newEstablishmentName = val"
      @selectEstablishment="val => selectedEstablishment = val"
      @close="close"
      @confirm="removeSheets"
    )
</template>

<script>
import establishmentService from '@/services/establishments.js';
import RcModal from '@/components/RcModal.vue';
import { rcLoader } from '@/directives/rc-loader/rcLoader.js';

export default {
  directives: { rcLoader },
  components: {
    RcModal,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
    potentialEstablishments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      sheetAggregates: null,
      destinationSource: 'new-establishment',
      newEstablishmentName: '',
      selectedEstablishment: null,
    };
  },
  methods: {
    close() {
      this.sheetAggregates = null;
      this.destinationSource = 'new-establishment';
      this.selectedEstablishment = null;
      this.newEstablishmentName = '';
      this.$router.replace({ name: 'Establishment' });
    },
    async removeSheets() {
      this.loading = true;
      const sheetIds = this.sheetAggregates.map(it => it.reference.value);
      if (this.destinationSource === 'new-establishment') {
        await establishmentService.create({
          name: this.newEstablishmentName,
          sheetIds,
        });
      } else {
        await establishmentService.moveSheetsToEstablishment({
          establishmentId: this.selectedEstablishment.id,
          sheetIds,
        });
      }
      this.loading = false;
      this.$emit('remove');
      this.close();
    },
  },
  computed: {
    isOpen() {
      const correctRoute = this.$route.matched.some(({ name }) => name === 'RemoveSheets');
      return correctRoute && !!this.sheetAggregates?.length;
    },
  },
}
</script>

<style lang="scss">
  .remove-sheets-modal .rc-modal-container {
    max-height: 800px;
    height: 90vh;
    .router-view {
      height: 100%; 
      display: flex;
      flex-direction: column;
      align-items: space-between;
      justify-content: space-between;
      .title-block {
        margin-bottom: 4em;
        text-align: center;
        .title {
          font-size: 32px;
          margin-bottom: .5em;
        }
        .subtitle {
          font-size: 20px;
          color: #8A8A8A;
        }
      }
      .actions {
        align-self: flex-end;
        margin-top: 1em;
        button {
          margin: 0 .5em;
          &.previous-btn, &.cancel-btn {
            background: #393939;
            border-color: #666666;
          }
          &:disabled {
            opacity: 0.5;
            cursor: default;
          }
        }
      }
    }
  }
</style>

